import { c as _c } from "react/compiler-runtime";
import { useCallback, useState } from "react";
export function useWaveCreatorPreviewModal() {
  const $ = _c(4);
  const [isModalOpen, setIsModalOpen] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setIsModalOpen(true);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const handleBadgeClick = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setIsModalOpen(false);
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleModalClose = t1;
  let t2;
  if ($[2] !== isModalOpen) {
    t2 = {
      isModalOpen,
      handleBadgeClick,
      handleModalClose
    };
    $[2] = isModalOpen;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}